module.exports = __webpack_public_path__ + "img/batam1.77d8f376.jpg";